import { createSelector } from 'reselect'
import serviceAuthorized from '../utility/serviceAuthorized'

const getAuthorizedServices = state => {
  return state.login.layers
}

const getServices = (state, services) => {
  return state.service.services
}

export const makeGetServiceAuthorized = () => {
  return createSelector(
    [getAuthorizedServices, getServices],
    (authorizedServices, services) => {
      // console.log(authorizedServices)
      // console.log(services)
      // console.log(serviceAuthorized(authorizedServices, services))
      return serviceAuthorized(authorizedServices, services)
    }
  )
}



// WEBPACK FOOTER //
// ./src/selectors/serviceAuthorizationSelector.js